const MANUAL_CREDIT_OWNER_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const MANUAL_CREDIT_OWNER_EMAIL = 'valeriobianconi@gmail.com';

export function canManuallyManageCredit(authUser) {
  return authUser?.uid === MANUAL_CREDIT_OWNER_UID
    && String(authUser?.email || '').trim().toLowerCase() === MANUAL_CREDIT_OWNER_EMAIL;
}
